import React, { useState } from 'react';
import { PolicyModal } from './PolicyModal';
export function FooterSection() {
  const [modalConfig, setModalConfig] = useState<{
    isOpen: boolean;
    title: string;
  }>({
    isOpen: false,
    title: ''
  });
  const openModal = (title: string) => {
    setModalConfig({
      isOpen: true,
      title
    });
  };
  const closeModal = () => {
    setModalConfig({
      ...modalConfig,
      isOpen: false
    });
  };
  return <footer className="bg-zen-beige py-12 px-5 mt-12" data-id="element-27">
      <div className="max-w-4xl mx-auto text-center" data-id="element-28">
        <div className="flex flex-wrap justify-center gap-6 mb-8 text-sm font-medium text-slate-dark/70" data-id="element-29">
          <button onClick={() => openModal('Política de Privacidad')} className="hover:text-slate-dark transition-colors" data-id="element-30">
            Política de Privacidad
          </button>
          <button onClick={() => openModal('Términos y Condiciones')} className="hover:text-slate-dark transition-colors" data-id="element-31">
            Términos y Condiciones
          </button>
          <a href="mailto:soporte@mascotagenial.com" className="hover:text-slate-dark transition-colors" data-id="element-32">
            Soporte
          </a>
        </div>

        <p className="text-xs text-slate-dark/50 mb-6 max-w-2xl mx-auto" data-id="element-33">
          Descargo de responsabilidad: Este producto digital tiene fines
          educativos y de entrenamiento. No reemplaza la consulta veterinaria
          profesional ni la evaluación de un etólogo clínico en casos de
          agresividad severa o problemas neurológicos.
        </p>

        <p className="text-sm font-bold text-slate-dark/40" data-id="element-34">
          © {new Date().getFullYear()} Mascota Genial®. Todos los derechos
          reservados.
        </p>
      </div>

      <PolicyModal isOpen={modalConfig.isOpen} onClose={closeModal} title={modalConfig.title} data-id="element-35" />
    </footer>;
}